import React from "react";

import BaseIcon from "../BaseIcon";

const FilterIcon = props => (
  <BaseIcon viewBox="0 0 364 332" {...props}>
    <g stroke="currentColor" strokeWidth="20" fill="none" fillRule="evenodd">
      <g transform="translate(10 262)">
        <path
          d="M.36595745 25.5H215.741643m87.408814 0h40.483586"
          strokeLinecap="round"
        />
        <circle cx="259" cy="25" r="35" />
      </g>
      <g transform="translate(10 141)">
        <path
          d="M.36595745 25.5H41.259323m88.372026 0h214.002694"
          strokeLinecap="round"
        />
        <circle cx="85" cy="25" r="35" />
      </g>
      <g transform="translate(10 20)">
        <path
          d="M.36595745 25.5H215.150047m88.844021 0h39.639975"
          strokeLinecap="round"
        />
        <circle cx="259" cy="25" r="35" />
      </g>
    </g>
  </BaseIcon>
);

export default FilterIcon;
